import { CloseOutlined } from '@ant-design/icons';
import { Button, Divider, Typography } from 'antd';
import React from 'react';

import type { Instructor } from '@/types/database/instructor';

import InstructorInfo from './components/InstructorInfo';

const { Text } = Typography;

import imgPlaceHolder from '@/assets/pink-one/imgPlaceHolder.svg';

import styles from './styles.module.scss';

const InstructorInfoBox: React.FC<{
  instructor: Instructor | null;
  closeInfoBox: () => void;
}> = ({ instructor, closeInfoBox }) => {
  return (
    <div
      className={`${styles['instructor-info__div']} ${
        !instructor ? styles['instructor-info__div--hide'] : ''
      }`}
    >
      <div className={styles['instructor-info__div--inner']}>
        <header className={styles['instructor-info__header']}>
          <Text className={styles['instructor-info__title']}>人員資訊</Text>
          <Button
            type="text"
            color="#999999"
            className={styles['instructor-info__close-button']}
            icon={<CloseOutlined />}
            onClick={closeInfoBox}
          />
        </header>
        {instructor && (
          <div className={styles['instructor-info__body']}>
            <section>
              <img
                src={instructor.image || imgPlaceHolder}
                alt="instructor-avatar"
                className={styles['instructor-info__avatar']}
              />
              <InstructorInfo label="姓名" value={instructor.name} />
              <InstructorInfo label="手機號碼" value={instructor.phone} />
              <InstructorInfo label="頭銜" value={instructor.title} />
            </section>
            <Divider className={styles['instructor-info__divider']} />
            <section>
              <InstructorInfo label="專長" value={instructor.expertise} />
              <InstructorInfo label="簡介" value={instructor.introduction} />
            </section>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstructorInfoBox;
